import React from "react";


const About = () => {
  return (
    <div id="" className="py-10">
      <div className="grid md:gap-10 place-items-center">
          <p className="text-lg text-gray leading-7 sm:px-32">
          Guru Harkrishan High School believes in enlightening and educating children in a stress free friendly atmosphere. The aim of this institution is to provide holistic education that enables growth, optimism and hard work.
At GHK success is not a myth or a dream. It is easily attainable in all spheres of life. Ample opportunities are given to our students to excel in all fields of life. The school prides itself on its academic rigour and student centric approach. GHK allows each child to grow into a wholesome, skilled, competent individual.
I have been associated with this institution for more than two decades and I feel proud to belong to this institution as a teacher and feel amply rewarded for being here.
I am quite confident about the way in which our institution is moving. We will surely fulfill the requirements and ambitions of our students.
We cater to the holistic development of our children and leave no stone unturned to develop them into good human beings. Our efforts will enable our students to have a rounded personality and overall and all-sided development. Our reward is when our students are successful in life.
          </p>
        </div>
    </div>
  );
};

export default About;